<template>
  <el-dialog title="选择要导入的模板" :visible.sync="dialogVisible" width="700px" style="height:600px" @closed="handleClose">
    <template>
      <div>
            <div class="import-content">
                <el-card class="import-item" v-for="item in tabListData" :key="item.templateId" shadow="hover">
                    <el-radio-group v-model="currentTemplateId">
                        <el-radio :label="item.templateId">{{item.templateName}}</el-radio>
                    </el-radio-group>
                </el-card>
            </div>
        
      </div>
    </template>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
//   import { specification_mixin } from '../components/FormItemSpecification';
import { getTmImportTemplate } from '@/servers/prod/center/tm';
//   import { cloneDeep } from 'lodash';
export default {
  name: 'ImportTemplateFromTm',
  inject: ['TmStep3'],
  data() {
    return {
      dialogVisible: false,
      tabListData: [],
      tabledFormData: [],
      currentTemplateId: '',
      currentFormData: {},
    };
  },
  methods: {
    handleShow() {
      this.dialogVisible = true;
      this.getImportTemplateDetail();
    },
    async getImportTemplateDetail() {
        const _shopId = this.TmStep3.oriDatas[0].shopId
        const res = await getTmImportTemplate({
          shopId: _shopId,
        });
        this.tabledFormData = res;
        this.tabListData = res.map(item => {
          return { templateId: item.templateId, templateName: item.templateName };
        });
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('on-cancel');
    },
    handleSubmit() {
        this.currentFormData = this.tabledFormData.find(item => item.templateId == this.currentTemplateId);
        console.log(this.currentFormData,58);
        const data = Object.assign({}, this.currentFormData)
        this.$emit('on-success', data)
        this.dialogVisible = false
    }
  },

  // tab change事件
  handleTabClick(id) {
    this.currentTemplateId = id;
  },
};
</script>

<style>

.import-content{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.import-item{
    width: 320px;
    margin-bottom: 10px;
}
::v-deep .el-radio-group{
  width: 100%;
  height: 100%;
}
::v-deep .el-radio{
  width: 100%;
  height: 100%;
}

</style>
